import { Inject, Injectable } from '@angular/core';
import {
  CompanyGuiControllerGetByFilterRemoteMethod,
} from 'open-api-legacy/remote-methods/company-gui-controller-get-by-filter.remote-method';
import { GetByFilterToTableMethod } from 'eurogard-table-system';
import { RxapDataSource } from 'eurogard-data-source';
import { DynamicTableDataSource } from 'eurogard-data-source/table';

@Injectable()
@RxapDataSource('company-gui')
export class CompanyGuiTableDataSource extends DynamicTableDataSource {
  constructor(@Inject(CompanyGuiControllerGetByFilterRemoteMethod) getByFilter: CompanyGuiControllerGetByFilterRemoteMethod) {
    super(new GetByFilterToTableMethod(getByFilter));
  }
}
